import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { ApolloDocumentService } from './api/apolloDocument.service';
import { ApolloDocumentLineResourceService } from './api/apolloDocumentLineResource.service';
import { ApolloDocumentResourceService } from './api/apolloDocumentResource.service';
import { ApplicationModuleResourceService } from './api/applicationModuleResource.service';
import { ContextGroupResourceService } from './api/contextGroupResource.service';
import { ContextModuleResourceService } from './api/contextModuleResource.service';
import { ContextUserEopooResourceService } from './api/contextUserEopooResource.service';
import { ContextUserResourceService } from './api/contextUserResource.service';
import { CustomRolePermissionResourceService } from './api/customRolePermissionResource.service';
import { CustomRoleResourceService } from './api/customRoleResource.service';
import { EntityReferenceResourceService } from './api/entityReferenceResource.service';
import { EopooApiControllerService } from './api/eopooApiController.service';
import { FatturaPaService } from './api/fatturaPa.service';
import { PermissionResourceService } from './api/permissionResource.service';
import { RoleAssignationResourceService } from './api/roleAssignationResource.service';
import { RoleResourceService } from './api/roleResource.service';
import { TenantContextResourceService } from './api/tenantContextResource.service';
import { UserPermissionMemoryResourceService } from './api/userPermissionMemoryResource.service';
import { UserResourceService } from './api/userResource.service';
import { UserToContextResourceService } from './api/userToContextResource.service';
import { VerifyUserPermissionApiControllerService } from './api/verifyUserPermissionApiController.service';
import { WsUserContextService } from './api/wsUserContext.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    ApolloDocumentService,
    ApolloDocumentLineResourceService,
    ApolloDocumentResourceService,
    ApplicationModuleResourceService,
    ContextGroupResourceService,
    ContextModuleResourceService,
    ContextUserEopooResourceService,
    ContextUserResourceService,
    CustomRolePermissionResourceService,
    CustomRoleResourceService,
    EntityReferenceResourceService,
    EopooApiControllerService,
    FatturaPaService,
    PermissionResourceService,
    RoleAssignationResourceService,
    RoleResourceService,
    TenantContextResourceService,
    UserPermissionMemoryResourceService,
    UserResourceService,
    UserToContextResourceService,
    VerifyUserPermissionApiControllerService,
    WsUserContextService ]
})
export class ApiGestModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders {
        return {
            ngModule: ApiGestModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiGestModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
